import React from 'react'

import { useFormReset, useModal } from 'hooks'

export const useInternalState = (state, handlers) => {
  const { create, data } = state
  const { onClose, onConfirm } = handlers

  const {
    isOpen: isConfirmationOpen,
    handleClose: handleDoubleConfirmationClose,
    handleOpen: handleDoubleConfirmationOpen,
  } = useModal()

  const handleClose = React.useCallback(handleDoubleConfirmationOpen, [
    handleDoubleConfirmationOpen,
  ])

  const handleCancel = React.useCallback(() => {
    handleDoubleConfirmationOpen()
  }, [handleDoubleConfirmationOpen])

  const handleConfirm = React.useCallback(() => {
    create.handleFormSubmit()
  }, [create])

  const handleConfirmationClose = React.useCallback(
    handleDoubleConfirmationClose,
    [handleDoubleConfirmationClose],
  )

  const handleConfirmationConfirm = React.useCallback(() => {
    create.handleFormReset()
    handleDoubleConfirmationClose()
    onClose()
  }, [create, handleDoubleConfirmationClose, onClose])

  React.useEffect(() => {
    if (create.formState.isSubmitSuccessful) {
      onConfirm(data, {
        onFailureAction: create.handleFormApiError,
      })
    }
  }, [create, data, onConfirm])

  useFormReset(
    { shouldReset: create.formState.isSubmitSuccessful },
    create.handleFormReset,
  )

  return {
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
    isConfirmationOpen,
  }
}
